import cx from 'classnames';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { INavbarItemProps } from './types';

export const NavbarItem = ({ text, icon, path, selected, onClick }: INavbarItemProps) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const isActive = useMemo(() => (path && pathname.includes(path)) || selected, [path, selected, pathname]);

  const handleClick = () => {
    if (path) navigate(path);
    if (onClick) onClick();
  };

  return (
    <div className="px-3 py-1">
      <div
        className={cx(
          'w-full flex items-center justify-start px-3 py-2 rounded-full hover:bg-background-button-primary hover:cursor-pointer hover:text-text-primaryInverse',
          { 'text-text-primary': !isActive },
          { 'bg-background-button-primary text-text-primaryInverse': isActive },
        )}
        onClick={handleClick}
      >
        <span className="mr-2">{icon}</span>
        <span className="typography-button-label-3">{text}</span>
      </div>
    </div>
  );
};
